import { render, staticRenderFns } from "./YessPartnerListItem.vue?vue&type=template&id=1560cd4c&scoped=true"
import script from "./YessPartnerListItem.vue?vue&type=script&lang=js"
export * from "./YessPartnerListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1560cd4c",
  null
  
)

export default component.exports